const menus: Menu[] = [
  { text: 'เกี่ยวกับเรา', link: '/about' },
  { text: 'กิจกรรม', link: '/event' },
  { text: 'บทความ', link: '/article' },
  { text: 'วิดีโอ', link: '/video' },
  { text: 'ฟอรั่ม', link: '/forum' },
  { text: 'CSA2022', link: '/csa2022' },
];

export default menus;
